export default __webpack_public_path__ + "static/media/j6Bkh5Z5voQ-HD.4accc333.jpg";